import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";

/**
 * Logs "Read More" button click event for About Stock section.
 */
export const handleAboutStockReadmoreDL = (
  loginStatus: string,
  sectionTitle: string,
  ctaText: string,
) => {
  const data = {
    section_title: sectionTitle,
    component: componentNameConstants.SCRIP_OVERVIEW,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.BUTTON_CLICK,
    element: dlElementConstants.SCRIP_OVERVIEW_READ_MORE,
    cta_text: ctaText,
  };

  const cleverTapObj = {
    EVENT_NAME: dlElementConstants.SCRIP_OVERVIEW_READ_MORE,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};

/**
 * Logs modal close action from About Stock modal.
 * Can distinguish between button click and icon (X) click.
 */
export const handleCloseBtnDL = (
  loginStatus: string,
  sectionTitle: string,
  ctaText: string,
  btnClick = false,
) => {
  const data = {
    section_title: sectionTitle,
    component: componentNameConstants.SCRIP_OVERVIEW,
    event: dlEventConstants.CLICK,
    event_type: btnClick
      ? dlEventConstants.BUTTON_CLICK
      : dlEventConstants.ICON_CLICK,
    element: btnClick
      ? dlElementConstants.SCRIP_OVERVIEW_BTN_CLICK
      : dlElementConstants.SCRIP_OVERVIEW_ICON_CLICK,
    cta_text: ctaText,
  };

  const cleverTapObj = {
    EVENT_NAME: btnClick
      ? dlElementConstants.SCRIP_OVERVIEW_BTN_CLICK
      : dlElementConstants.SCRIP_OVERVIEW_ICON_CLICK,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};
